// extracted by mini-css-extract-plugin
export default {"history-container":"HistoryDownloadDialog_history-container__amkj8","leave-history":"HistoryDownloadDialog_leave-history__yoMko"};